import { render, staticRenderFns } from "./SelCheckCard.vue?vue&type=template&id=0ffbba04&"
import script from "./SelCheckCard.vue?vue&type=script&lang=js&"
export * from "./SelCheckCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports